import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-34015a76")

_pushScopeId("data-v-34015a76")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Commesse")
const _hoisted_2 = {
  key: 0,
  class: "qr_scanner_modal"
}
const _hoisted_3 = { class: "qr_scanner_container" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "scanner_title" }, "Scansiona QR Commessa", -1)
const _hoisted_5 = { class: "qr_code_scanner" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "scanner_frame" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "scanner_instructions" }, " Inquadra il codice QR della commessa ", -1)
const _hoisted_8 = {
  key: 0,
  class: "scan_result"
}
const _hoisted_9 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_10 = {
  key: 1,
  class: "page_content"
}
const _hoisted_11 = {
  key: 0,
  class: "no_clienti_container"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "no_clienti" }, "Nessuna commessa da visualizzare", -1)
const _hoisted_13 = {
  key: 1,
  class: "container_progetti"
}
const _hoisted_14 = { class: "scan_commessa_qr" }
const _hoisted_15 = { class: "progetto_info" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "stato_progetto" }
const _hoisted_18 = { class: "customer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_qr_stream = _resolveComponent("qr-stream")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadCommesse()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode(_Transition, { name: "fade-transition" }, {
            default: _withId(() => [
              ($setup.showQrScanner)
                ? (_openBlock(), _createBlock("div", _hoisted_2, [
                    _createVNode("div", _hoisted_3, [
                      _hoisted_4,
                      _createVNode("div", _hoisted_5, [
                        _createVNode(_component_qr_stream, {
                          onDecode: $setup.onQrDecode,
                          class: "scanner"
                        }, {
                          default: _withId(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }, 8, ["onDecode"])
                      ]),
                      _hoisted_7,
                      ($setup.scanResult)
                        ? (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString($setup.scanResult), 1))
                        : _createCommentVNode("", true),
                      _createVNode("button", {
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.closeQrScanner && $setup.closeQrScanner(...args))),
                        class: "btn_close_scanner"
                      }, "Chiudi")
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_10, [
                ($setup.commesse.length == 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      _hoisted_12
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        _createVNode("button", {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.scanCommessaQR()))
                        }, "Scansiona QR")
                      ]),
                      _createVNode("div", null, [
                        _createVNode(_component_ion_input, {
                          type: "text",
                          "clear-input": "",
                          modelValue: $setup.searchQuery,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($setup.searchQuery = $event)),
                          placeholder: "Cerca commessa",
                          class: "search_projects"
                        }, null, 8, ["modelValue"])
                      ]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.filteredCommesse, (commessa) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "progetto",
                          key: commessa.projects_id,
                          onClick: ($event: any) => ($setup.openProject(commessa))
                        }, [
                          _createVNode("div", _hoisted_15, [
                            _createVNode("div", _hoisted_16, [
                              _createVNode("span", null, _toDisplayString($setup.setShortName(commessa.projects_name)), 1),
                              _createVNode("div", _hoisted_17, [
                                _createVNode("span", {
                                  class: ["badge", $setup.commessaStatus(commessa.projects_status)]
                                }, _toDisplayString(commessa.projects_status_value), 3)
                              ])
                            ]),
                            _createVNode("div", _hoisted_18, _toDisplayString($setup.riferimentoCliente(commessa)), 1)
                          ])
                        ], 8, ["onClick"]))
                      }), 128))
                    ]))
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})